// extracted by mini-css-extract-plugin
export var chevronIcon = "_au-2";
export var teamName = "_au-1";
export var teamSwitcherButton = "_au-0";